// The bank resolves a settlement account's name after signup, so it can still be null.
export const NAME_PENDING = "Name pending verification";

// Deleting a sub-merchant is refused above this balance, which every withdrawal leaves behind.
export const SUB_MERCHANT_DELETE_THRESHOLD = 1000;

export const PAYOUT_REFUSAL_REASONS = {
  enterprise_inactive: "The enterprise is deactivated",
  not_in_enterprise: "This store is no longer in your enterprise",
  no_wallet: "This store has no wallet",
  in_progress: "A transfer is still processing",
  nothing_to_pay_out: "Nothing to pay out — ₦500 always stays in the wallet",
};

// These two refusals come from the bank's name enquiry and only CashAfrica can clear them.
export const PAYOUT_SUPPORT_REFUSALS = [
  "The enterprise settlement account could not be verified with the bank. Update it and try again.",
  "The settlement account name returned by the bank no longer matches. A CashCard admin must re-verify the bank account.",
];

export const PAYOUT_THROTTLED = "Too many attempts. Please slow down and try again later.";

export const Constants = {
  teamMemberStatuses: ["active", "deactivated", "pending verification"],

  // A separate backend enum from teamMemberStatuses that currently happens to hold the same
  // values. Aliasing one to the other would corrupt a screen the day either enum moves.
  externalUserStatuses: ["active", "deactivated", "pending verification"],

  transactionStatuses: [
    "processing",
    "completed",
    "failed",
    "declined",
    { value: "timeout", label: "Timed out" },
    "cancelled",
  ],

  // A withdrawal is never declined, and the API answers filter[status]=declined with a 422.
  withdrawalStatuses: ["processing", "completed", "failed", { value: "timeout", label: "Timed out" }, "cancelled"],

  subMerchantStatuses: ["active", "deactivated"],

  ledgerEntryTypes: {
    tap_settlement: { label: "Tap settlement", tone: "success" },
    withdrawal: { label: "Withdrawal", tone: "danger" },
    withdrawal_reversal: { label: "Withdrawal reversal", tone: "warning" },
    withdrawal_provider_fee: { label: "Provider fee", tone: "secondary" },
  },

  enterpriseLedgerTypes: {
    credit: { label: "Credit", tone: "success" },
    debit: { label: "Debit", tone: "danger" },
  },

  payoutStatuses: ["pending", "unpaid", "paying", "success", "failed", "close", "unknown"],

  // filter[status] matches delivery response codes exactly and offers no ranges or negation, so
  // each bucket is sent as the explicit list of codes it covers.
  webhookStatusFilters: [
    { value: "200,201,202,203,204", label: "Delivered (2xx)" },
    { value: "400,401,403,404,408,409,410,422,429", label: "Client error (4xx)" },
    { value: "500,501,502,503,504", label: "Server error (5xx)" },
    { value: "transport_error", label: "No response" },
  ],
  webhookTypes: [
    "external user registered",
    "external user tapped",
    "external user tap failed",
    "external user payout settled",
    "external user payout failed",
  ],

  // CashTap Agent constants
  // The agent endpoints are a merchant API and report a wider status set than the partner ledger.
  agentTransactionStatuses: ["successful", "completed", "pending", "failed", "declined"],
  commissionStatuses: ["pending", "paid", "failed"],
  agentActiveStatuses: ["active", "inactive"],
};
